import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash.isempty';
import { ADDON_TYPE } from '@shootsta/common-domain-data';
import { Text, Checkbox, Icon } from '../../../../../ui-kit';
import {
  getAddonsCostByType as getAddonsCostByTypeUtil,
  getCurrency as getCurrencyUtil } from
'../../../utils';
import EditCost from '../../Expandable/common/EditCost/components/EditCost';

import '../styles/_custom-addons.scss';

























function CustomAddonsSection({
  CAPTIONS,
  onSelectedAddon,
  updatedAppliedAddons,
  billingEntityCode,
  addonsWithCosts,
  selectedBillingEntityCode,
  onChangedBillingEntityCode
}) {
  const getCurrency = getCurrencyUtil(billingEntityCode);
  const getAddonsCostByType = getAddonsCostByTypeUtil(addonsWithCosts, billingEntityCode);

  const burnInCaptionstype = ADDON_TYPE.BURN_IN_CAPTIONS;
  const srtCaptionstype = ADDON_TYPE.SRT_CAPTIONS;

  const burnInCaptions = CAPTIONS && !isEmpty(CAPTIONS(burnInCaptionstype)) ?
  CAPTIONS(burnInCaptionstype).map((item) => ({
    ...item,
    ...{
      selected: false,
      cost: getAddonsCostByType({
        addonType: burnInCaptionstype,
        numberValue: true
      }),
      icon: 'burnin',
      costChanged: false,
      subLabel: ''
    }
  })) : [];

  const srtCaptions = CAPTIONS && !isEmpty(CAPTIONS(srtCaptionstype)) ?
  CAPTIONS(srtCaptionstype).map((item) => ({
    ...item,
    ...{
      selected: false,
      cost: getAddonsCostByType({
        addonType: srtCaptionstype,
        numberValue: true
      }),
      icon: 'transcribe',
      costChanged: false,
      subLabel: ''
    }
  })) : [];

  const addonData = [
  {
    title: 'Captions (Burn in)',
    addonType: burnInCaptionstype,
    addonValues: burnInCaptions
  },
  {
    title: 'Captions (SRT)',
    addonType: srtCaptionstype,
    addonValues: srtCaptions
  },
  {
    title: 'Voice Over Artist',
    addonType: ADDON_TYPE.VOICE_OVER_ARTIST,
    addonValues: [{
      label: 'Professional voice',
      subLabel: '',
      prefix: 'voiceover',
      selected: false,
      cost: getAddonsCostByType({
        addonType: ADDON_TYPE.VOICE_OVER_ARTIST,
        numberValue: true
      }),
      costChanged: false,
      value: 'VOA'
    }]
  },
  {
    title: 'Social Iterations',
    addonType: ADDON_TYPE.ADDITIONAL_OUTPUT,
    addonValues: [{
      label: 'Additional Outputs',
      subLabel: '',
      prefix: 'square',
      selected: false,
      cost: getAddonsCostByType({
        addonType: ADDON_TYPE.ADDITIONAL_OUTPUT,
        numberValue: true
      }),
      costChanged: false,
      value: 'AO'
    }]
  }];


  const buildAppliedAddons = () => addonData.map((addon) => {
    // $FlowFixMe Flow does not yet support method or property calls in optional chains.
    const addonAsPerType = updatedAppliedAddons?.find(
      (updatedAddon) => updatedAddon.addonType === addon.addonType
    );

    if (!addonAsPerType) {
      return addon;
    }

    return {
      ...addon,
      addonValues: addon.addonValues.map((addonValue) => {
        const addonValuePerType = addonAsPerType.addonValues.find(
          (it) => it.value === addonValue.value
        );

        if (!addonValuePerType) {
          return addonValue;
        }

        return {
          ...addonValue,
          cost: addonValuePerType.cost,
          costChanged: addonValuePerType.costChanged,
          selected: addonValuePerType.selected,
          value: addonValuePerType.value
        };
      })
    };
  });

  const initialAddonValues = updatedAppliedAddons && updatedAppliedAddons?.length > 0 ?
  buildAppliedAddons() : addonData;
  const [selectedAddonValues, setSelectedAddonValues] = useState(initialAddonValues);

  useEffect(() => {
    if (selectedBillingEntityCode !== billingEntityCode) {
      onChangedBillingEntityCode(billingEntityCode);
      setSelectedAddonValues(addonData);
    }
  }, [selectedBillingEntityCode, billingEntityCode]);

  useEffect(() => {
    onSelectedAddon(selectedAddonValues);
  }, [selectedAddonValues]);

  const onChangeAddon = (selected, costValue, addonValues, index, mainIndex) => {
    const updatedValue = [...selectedAddonValues];
    const updatedAddons = [...addonValues];

    if (costValue > 0) {
      if (costValue !== updatedAddons[index].cost) {
        updatedAddons[index].cost = costValue;
        updatedAddons[index].costChanged = true;
        updatedValue[mainIndex].addonValues = updatedAddons;
        return setSelectedAddonValues(updatedValue);
      }
      return null;
    }

    updatedAddons[index].selected = !selected;
    updatedAddons[index].cost = costValue;
    updatedAddons[index].costChanged = false;
    updatedValue[mainIndex].addonValues = updatedAddons;
    return setSelectedAddonValues(updatedValue);
  };

  const customAddonComponent = (title, addonValues, mainIndex) => {
    if (!addonValues) {
      return null;
    }

    return (
      <div key={title} className="custom-addons__section">
        <div className="custom-addons__title">
          <Text heading4>{title}</Text>
        </div>
        {addonValues.map(({ label, subLabel, prefix, selected, cost }, index) =>
        <div key={label} className="custom-addons__container">
            <Checkbox
            checked={selected}
            onChange={() => onChangeAddon(selected, 0, addonValues, index, mainIndex)}
            className="custom-addons__container__checkbox">

              <Icon className="custom-addons__container__icon" name={prefix} size={22} />
              <div>
                <Text heading5 className="custom-addons__container__title">{label}</Text>
                {subLabel !== '' && <Text className="custom-addons__container__subtitle">{subLabel}</Text>}
              </div>
            </Checkbox>
            <EditCost
            onChangeCost={(costValue) => onChangeAddon(
              selected,
              costValue,
              addonValues,
              index,
              mainIndex
            )}
            addonName="CUSTOM_ADDON"
            cost={Number(cost) || 0}
            getCurrency={getCurrency}
            className="custom-addon"
            disabled={selected} />

          </div>
        )}
      </div>);

  };

  return (
    <div className="custom-addons">
      {
      selectedAddonValues.map(({ title, addonValues }, mainIndex) =>
      customAddonComponent(title, addonValues, mainIndex)
      )}

    </div>);

}

export default CustomAddonsSection;